import styled from 'styled-components';
import { ANIMATION_CURVE, ANIMATION_DURATION } from '@optimus-web/common';
import { MEDIA_QUERY, Stack, StackItem } from '@optimus-web/core';

export const ContentStack = styled(Stack)<{ isSidebarShown: boolean }>`
    ${MEDIA_QUERY.tabletMax} {
        ${(props) => (props.isSidebarShown ? 'gap: 0;' : '')}
    }
`;

export const MainContent = styled(StackItem)`
    overflow-y: auto;
    transition: all ${ANIMATION_CURVE.default} ${ANIMATION_DURATION.default}ms;
`;
